import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '-';
    const date = moment.utc(value);

    return date.format('DD/MM/YYYY HH:mm:ss');
  }
}
